import { getExperiments } from '../repositories/experimentRepository'

export function getBucket(experimentName: string) {
  return getExperiments()[experimentName]
}
